import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = { id: "key" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Loading..."))
        : (!_ctx.isConnected)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.bootstrap && _ctx.bootstrap(...args)))
            }, "Connect"))
          : (_ctx.isConnected)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "SCRT Balance: " + _toDisplayString(_ctx.coinConvert(_ctx.balance, 6, 'human', 2)), 1))
            : _createCommentVNode("", true)
    ])
  ], 64))
}